<div class="c-container c-m-top-pd muni-user-settings">
  <section class="c-m-top-md muni-user-settings__app-settings">
    <div class="c-card">
      <header class="c-card-header">
        <div class="c-card-header-title c-row">
          <div class="c-col-10 c-col-md-6 c-col-lg-4">
            <span>Application Settings</span>
          </div>
        </div>
      </header>
      <div class="c-card-content card-content-toggle c-p-bottom-lg">
        <div class="c-card-content-body">
          <div class="c-container">
            <form [formGroup]="userSettingsForm">
              <div class="c-row">
                <div class="c-col">
                  <div
                    class="muni-user-settings__row--fixed c-row c-align-center c-bd-gray-2 c-p-bottom-md"
                  >
                    <div class="c-col-5 c-p-horizontal-0">
                      <div>Default Benchmark Curve</div>
                    </div>
                    <div
                      *ngIf="userSettings.defaultBenchmarkCurve"
                      class="c-col-4 c-col-align-start"
                    >
                      <select
                        class="c-input app-settings__e2e--default-benchmark-curve"
                        [class.muni-user-settings__app-settings__input--invalid]="
                          isMmdAlertShown()
                        "
                        formControlName="defaultBenchmarkCurve"
                      >
                        <option
                          *ngFor="
                            let curve of benchmarkCurveModel
                              | keyvalue
                                : (!hasMmdDataPermission
                                    ? sortByPermission
                                    : disableSorting)
                          "
                          [value]="curve.value"
                        >
                          {{ curve.value }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div
                    class="muni-user-settings__row--fixed c-row c-align-center c-bd-gray-2 c-p-bottom-md"
                  >
                    <div class="c-col-5 c-p-horizontal-0">
                      <div>Default Street Calendar Flex Column</div>
                    </div>
                    <div
                      *ngIf="userSettings.defaultFlexColumn"
                      class="c-col-4 c-col-align-start"
                    >
                      <select
                        class="c-input app-settings__e2e--default-flex-column"
                        formControlName="defaultFlexColumn"
                      >
                        <option
                          *ngFor="
                            let column of flexColumnModel
                              | keyvalue: disableSorting
                          "
                          [value]="column.value"
                        >
                          {{ column.value }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div
                    class="muni-user-settings__row--fixed c-row c-align-center c-bd-gray-2 c-p-bottom-md"
                  >
                    <div class="c-col-5 c-p-horizontal-0">
                      <div>Deal Cards View</div>
                    </div>
                    <div class="c-col-4 c-col-align-start">
                      <div class="c-checkbox">
                        <input
                        type="checkbox"
                        id="defaultDealCardsViewCheckbox"
                        formControlName="defaultDealCardsView"
                        value="1">
                        <label for="defaultDealCardsViewCheckbox"></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
